export const CONUNTIRES_NAMES = "CONUNTIRES_NAMES";
export const FILTER_COUNTIRES = "FILTER_COUNTIRES";
export const CURRENT_STATS = "CURRENT_STATS";
export const MINI_GRAPHS_DATA = "MINI_GRAPHS_DATA";
export const DATA_FOR_TABLE = "DATA_FOR_TABLE";
export const DATA_FOR_ONE_COUNTRY = "DATA_FOR_ONE_COUNTRY";
export const DETAIL_DATA_FOR_ONE_COUNTRY = "DETAIL_DATA_FOR_ONE_COUNTRY";
